module.exports = __webpack_public_path__ + "media/images/icons/likes_fill-e5d89742c272841235888faaa1f6a391.svg";